import { render, staticRenderFns } from "./previousDonationTab.vue?vue&type=template&id=978d9448&scoped=true"
import script from "./previousDonationTab.vue?vue&type=script&lang=js"
export * from "./previousDonationTab.vue?vue&type=script&lang=js"
import style0 from "./previousDonationTab.vue?vue&type=style&index=0&id=978d9448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978d9448",
  null
  
)

export default component.exports